import { createStyles, makeStyles } from '@material-ui/core/styles';
export default makeStyles(theme => {
  return createStyles({
    vehicleRoot: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      backgroundColor: 'transparent',
      marginBottom: theme.spacing(3)
    },
    information: {
      display: 'flex',
      alignItems: 'center',
      width: '100%'
    },
    leftAlignedBox: {
      alignSelf: 'flex-start',
      width: '100%'
    },
    spacingLeft: {
      marginLeft: theme.spacing(2)
    },
    buttonGroup: {
      marginTop: theme.spacing(3),
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between'
    },
    headerRow: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      flexWrap: 'wrap'
    },
    subscriptionBadgeBasic: {
      fontWeight: 600,
      fontSize: '0.75rem',
      height: '22px',
      backgroundColor: theme.palette.grey[200],
      color: theme.palette.text.primary,
      border: `1px solid ${theme.palette.grey[400]}`,
      '& .MuiChip-label': {
        padding: '0 8px',
        fontWeight: 500
      }
    },
    subscriptionBadgeStandard: {
      fontWeight: 700,
      fontSize: '0.75rem',
      height: '22px',
      background: `linear-gradient(45deg, ${theme.palette.primary.main} 30%, ${theme.palette.secondary.main} 90%)`,
      color: 'white',
      border: `1px solid ${theme.palette.primary.dark}`,
      boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
      '& .MuiChip-label': {
        padding: '0 6px',
        fontWeight: 700,
        color: 'white'
      },
      '& .MuiChip-icon': {
        color: 'white',
        fontSize: '14px',
        marginLeft: '4px'
      },
      '&:hover': {
        boxShadow: '0 3px 6px rgba(0,0,0,0.3)',
        transform: 'translateY(-1px)'
      },
      transition: 'all 0.2s ease-in-out'
    }
  });
});